import DoubleBox from './DoubleBox';

export default DoubleBox;
